export default {
    namespace: 'JoinFutureWorld',
    translations: {
        zh: {
            hero: {
                kicker: 'CAREERS',
                title: '加入未来世界',
                description: '面向全球视野与技术成长，我们正在寻找愿意在国际化环境中持续发展的伙伴，与我们一起连接技术人才、企业需求与长期机会。'
            },
            switcher: {
                label: 'POSITIONS',
                title: '选择目标岗位'
            },
            overview: {
                label: 'ROLE OVERVIEW',
                title: '岗位说明'
            },
            meta: {
                publishedAt: '发布时间'
            },
            requirements: {
                label: 'ROLE PROFILE',
                title: '岗位要求'
            },
            contact: {
                label: 'APPLY NOW',
                title: '联系与投递',
                description: '电话、邮箱和二维码说明都会随当前岗位切换。',
                phoneLabel: '联系电话',
                emailLabel: '联系邮箱',
                qrLabel: '招聘二维码',
                qrEmpty: '二维码暂未上传'
            },
            status: {
                loading: '岗位信息加载中...',
                emptyTitle: '暂未发布岗位',
                emptyDescription: '当前语言下还没有已发布岗位，请稍后再来看看。',
                errorTitle: '岗位信息加载失败',
                errorDescription: '当前无法读取招聘数据，请稍后重试。'
            }
        },
        en: {
            hero: {
                kicker: 'CAREERS',
                title: 'Join Future World',
                description: 'We are looking for people who want to grow in an international environment and connect technical talent, business needs, and long-term opportunities with us.'
            },
            switcher: {
                label: 'POSITIONS',
                title: 'Choose a role'
            },
            overview: {
                label: 'ROLE OVERVIEW',
                title: 'Position Summary'
            },
            meta: {
                publishedAt: 'Published'
            },
            requirements: {
                label: 'ROLE PROFILE',
                title: 'Job Requirements'
            },
            contact: {
                label: 'APPLY NOW',
                title: 'Contact and Apply',
                description: 'Phone, email, and QR details update with the selected role.',
                phoneLabel: 'Phone',
                emailLabel: 'Email',
                qrLabel: 'Recruitment QR Code',
                qrEmpty: 'QR code not uploaded yet'
            },
            status: {
                loading: 'Loading career positions...',
                emptyTitle: 'No published positions yet',
                emptyDescription: 'There are no published openings in the current language right now. Please check back later.',
                errorTitle: 'Failed to load career data',
                errorDescription: 'The recruitment data is temporarily unavailable. Please try again later.'
            }
        },
        ja: {
            hero: {
                kicker: 'CAREERS',
                title: '未来世界に参加する',
                description: '国際的な環境で成長しながら、技術人材と企業ニーズ、長期的な機会をつなぐ仲間を募集しています。'
            },
            switcher: {
                label: 'POSITIONS',
                title: '職種を選ぶ'
            },
            overview: {
                label: 'ROLE OVERVIEW',
                title: 'ポジション概要'
            },
            meta: {
                publishedAt: '公開日'
            },
            requirements: {
                label: 'ROLE PROFILE',
                title: '募集要件'
            },
            contact: {
                label: 'APPLY NOW',
                title: 'お問い合わせと応募',
                description: '電話・メール・QR 情報は選択した職種に合わせて切り替わります。',
                phoneLabel: '電話番号',
                emailLabel: 'メール',
                qrLabel: '採用QRコード',
                qrEmpty: 'QRコードはまだ登録されていません'
            },
            status: {
                loading: '求人情報を読み込み中...',
                emptyTitle: '公開中の求人はありません',
                emptyDescription: '現在の言語では公開中の求人がありません。しばらくしてからもう一度ご確認ください。',
                errorTitle: '求人情報の読み込みに失敗しました',
                errorDescription: '現在、採用データを取得できません。後ほど再度お試しください。'
            }
        }
    }
};
